import IconNode from '@components/base/icon-node';
import Typography from '@components/base/typography';
import { CSSProperties } from 'react';
import css from './index.module.scss';
import Images from '@assets/images';

interface UserCardProps {
  src?: string;
  primaryTitle: string;
  secondaryTitle: string;
  showPrimaryIcon?: boolean;
  showInfoIcon?: boolean;
  style?: CSSProperties;
}

const UserCard = (props: UserCardProps) => {
  const {
    src,
    primaryTitle,
    secondaryTitle,
    style,
    showPrimaryIcon = true,
    showInfoIcon = false
  } = props;
  return (
    <div className={css.userCardContainer} style={style}>
      {showPrimaryIcon && (
        <IconNode src={src} alt={`${primaryTitle} icon`} className={css.profileIcon} />
      )}
      <div className={css.userCardDetailColumn}>
        <div className={css.titleWrapper}>
          <Typography variant="span" className={css.primaryTitleLabel}>
            {primaryTitle}
          </Typography>
          {showInfoIcon && <IconNode src={Images.infoGrey} alt="info icon" />}
        </div>
        <Typography variant="body">{secondaryTitle}</Typography>
      </div>
    </div>
  );
};
export default UserCard;
